export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "84799431f3mshac84ef7680062d7p1fd8e6jsnc9a37b0fb843",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_MAP_API_URL = "https://tile.openweathermap.org/map";

export const WEATHER_API_KEY = "e5895f4c79a5941259a72124ffada913";

